import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { TeamDescriptor } from "./types";

export const getTeamData = reactQueryFetcherAdapter(
  cacheKey,
  (signal: AbortSignal, appGroupId: string, id: string): Promise<TeamDescriptor> => {
    return fetch(`/app_settings/territories_data/${id}`, "GET", { app_group_id: appGroupId }, { signal });
  }
);
